import { render, staticRenderFns } from "./RefinementList.vue?vue&type=template&id=21e1e9f8"
import script from "./RefinementList.vue?vue&type=script&lang=js"
export * from "./RefinementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports